import { useEffect, useState } from "react";
import CheckoutConfigRenderer from "../components/builder/CheckoutConfigRenderer";
import { CheckoutConfig, CheckoutDeviceType } from "../types/builder";

const CheckoutPreviewPage = () => {
  const [config, setConfig] = useState<CheckoutConfig | null>(null);

  const [device, setDevice] = useState<CheckoutDeviceType>(
    CheckoutDeviceType.DESKTOP
  );

  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.data.type === "cakto-checkout-config") {
        setConfig(event.data.config);
        setDevice(event.data.device);
      }
    });
  }, []);

  if (!config) {
    return <span className="text-red-600">Configuração inválida</span>;
  }

  return (
    <div className="w-full justify-center">
      <CheckoutConfigRenderer config={config} device={device} />
    </div>
  );
};

export default CheckoutPreviewPage;
